import { startSignUpWithEmail } from "actions/authFunctions"
import InputField from "components/utils/InputField"
import GetpackedLoginButton from "components/utils/loginButtons/GetpackedLoginButton"
import ProgressBar from "components/utils/ProgressBar"
import { useLastShop } from "hooks/misc/useLastShop"
import { useMemo, useState } from "react"
import zxcvbn from "zxcvbn"

interface EmailSignUpFormProps {
  defaultEmail?: string
}

const EmailSignUpForm = ({ defaultEmail }: EmailSignUpFormProps) => {
  const lastShop = useLastShop()
  const [email, setEmail] = useState(defaultEmail || "")
  const [passwordA, setPasswordA] = useState("")
  const [passwordB, setPasswordB] = useState("")

  const ratingResult = useMemo(() => (passwordA ? zxcvbn(passwordA) : undefined), [passwordA])

  const [asyncError, setAsyncError] = useState<undefined | "email" | "other" | "mismatch">(undefined)

  const handleSignUp = async () => {
    if (passwordA !== passwordB) {
      setAsyncError("mismatch")
      return
    }
    setAsyncError(undefined)
    try {
      const user = {
        email: email,
        password: passwordA,
      }
      await startSignUpWithEmail(user, lastShop || "welcome")
    } catch (error) {
      if (error) {
        console.error(error)
        //TODO: Adjust for signup errors, this is a login error
        setAsyncError((error as Error).message.includes("auth/user-not-found") ? "email" : "other")
      }
    }
  }

  const error =
    ratingResult && ratingResult?.score < 3
      ? "strength"
      : passwordA && passwordA !== passwordB
        ? "mismatch"
        : asyncError

  const errorMessage =
    error &&
    {
      email: "Es existiert schon ein Account zu dieser E-Mail",
      strength: "Das Passwort ist zu schwach",
      mismatch: "Die Passwörter stimmen nicht überein",
      other: "Ein Fehler ist aufgetreten, versuche es nachher nochmal",
    }[error]

  const buttonEnabled = email && passwordA === passwordB && ratingResult && ratingResult.score >= 3

  return (
    <>
      <style jsx>{`
        @keyframes slidein {
          from {
            max-height: 0px;
            opacity: 0;
          }

          to {
            max-height: 24px;
            opacity: 1;
          }
        }
        .errorMessage {
          margin: 0;
          max-height: 24px;
          opacity: 1;
          animation: slidein 0.15s linear;
        }
      `}</style>
      <InputField danger={error === "email"} type="email" value={email} onChange={e => setEmail(e.target.value)}>
        E-Mail Adresse
      </InputField>
      <InputField
        danger={error === "strength"}
        type="password"
        value={passwordA}
        onChange={e => setPasswordA(e.target.value)}
        name="password"
        autoComplete="new-password"
      >
        Passwort
      </InputField>
      <InputField
        danger={error === "strength" || error === "mismatch"}
        type="password"
        value={passwordB}
        onChange={e => setPasswordB(e.target.value)}
        name="password"
        autoComplete="new-password"
      >
        Passwort wiederholen
      </InputField>

      <ProgressBar percentage={(ratingResult?.score || 0.2) * 25} dangerBelow={25} yellowBelow={50} />
      {errorMessage ? <p className="errorMessage">{errorMessage}</p> : null}
      {/* <label>
        Hiermit stimme ich den{" "}
        <a href="https://getpacked.de/agb/" target="_blank" rel="noreferrer">
          AGB
        </a>
        {" und den "}
        <a href="https://getpacked.de/rechtliches/datenschutzerklaerung-shop-backend/" target="_blank" rel="noreferrer">
          Datenschutzbestimmungen für Shops
        </a>
        {" und der "}{" "}
        <a href="https://getpacked.de/datenschutz-app/" target="_blank" rel="noreferrer">
          Datenschutzerklärung
        </a>{" "}
        zu.
      </label>
      <Checkbox checked={consent} onClick={handleConsent} label="Zustimmen" /> */}
      <GetpackedLoginButton onClick={handleSignUp} disabled={!buttonEnabled} signUp />
    </>
  )
}

export default EmailSignUpForm
